
import * as React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Api } from "../../lib/Api";
import EditRestaurant, { IXhrUrls } from "./restaurant/EditRestaurant";
import { IRestaurant } from "../../interfaces/IRestaurant";

interface IRestaurantProfileProps {
    setUrl:any
    createNew:boolean
}

interface IRestaurantProfileState {
}

interface IConnectedResult{
    success         : string
    error           : string
    restaurants     : Array<IRestaurant>
}

export default class RestaurantProfile extends React.Component<IRestaurantProfileProps, IRestaurantProfileState>{

    private xhrUrls:IXhrUrls;
    private defaultUploadImage:string;

  	constructor(props:IRestaurantProfileProps){
        super(props);
        this.xhrUrls = {
            init:           '/restaurant/init',
            get:            '/restaurant/get',
            addOrModify:    '/restaurant/addOrModify'
        };
        this.defaultUploadImage = 'img/restaurant/icons/Photo_icon_3.svg';
    }

    render() {
        let currentRestaurantId = this.props.createNew===true?0:Api.getCurrentRestaurant().id;
        let title:string        = this.props.createNew===true?'New restaruant':'Profile settings';
        return (
            <div id="restaurant_edit">
               <Header title={title} setUrl={this.props.setUrl}></Header>

               <div className="content_section container">
                   <div className = "h1_box">
                       <h1>{title}</h1>
                   </div>
                    <section className="restaurant_profile">
                       <EditRestaurant
                            key={currentRestaurantId}
                            urlPrefix={''}
                            xhrUrls={this.xhrUrls}
                            defaultUploadImage={this.defaultUploadImage}
                            id={currentRestaurantId}
                            removeBtnDisabled={true}
                            idName={'restaurant'}
                            changed={ (wantToClose, restaurantId) => {
                                if ( this.props.createNew === true && restaurantId > 0 ) {
                                    Api.call('/restaurant/connect', {
                                        id:restaurantId
                                    }, (connectedResult:IConnectedResult)=>{
                                        if ( connectedResult.error === null ) {
                                            Api.setRestaurants(connectedResult.restaurants);
                                            Api.refreshCurrentRestaurant(restaurantId, false);
                                            this.props.setUrl('/restaurant/index/' + restaurantId, {});
                                        }else{
                                            alert(connectedResult.error);
                                        }
                                    });
                                }else{
                                    Api.call('/restaurant/getConnectedRestaurants', {}, (connectedResult:IConnectedResult)=>{
                                        Api.setRestaurants(connectedResult.restaurants);
                                        Api.refreshCurrentRestaurant(restaurantId, false);
                                        this.props.setUrl('/restaurant/index/' + restaurantId, {});
                                    });
                                }
                            } }
                        />
                    </section>
               </div>

               <Footer setUrl={this.props.setUrl}></Footer>
			</div>
        );
    }
}
